module.exports = __webpack_public_path__ + "static/scale-model-of-castle-park-in-corona-california-f3b0e1a1fb02dfcda569e650cfe350d4.png";